export default {"src":"/_next/static/media/Events-icons.24690b46.svg","height":28,"width":28};